module.exports = __webpack_public_path__ + "img/pic_15.32b032a5.gif";